import React from 'react';
import { Slider, Tooltip } from 'antd';
import Flyout from './Flyout';
import shared from './Flyout.module.css';
import styles from './PenFlyout.module.css';
import { ReactComponent as Dashed } from '../../../assets/dashed.svg';
import { ReactComponent as Dotted } from '../../../assets/dotted_1.svg';
import { ReactComponent as Solid } from '../../../assets/line.svg';

const LINE_STYLES = [
    ['dashed', 'Dashed line', Dashed],
    ['dotted', 'Dotted line', Dotted],
    ['solid', 'Solid line', Solid],
];

/** Width, colour and line style for the free-drawing brush. */
const PenFlyout = ({ options, apply, onClose }) => {
    const set = (key, value) => apply({ ...options, [key]: value });
    const lineStyle = options.lineStyle || 'solid';

    return (
        <Flyout title="Pen" onClose={onClose}>
            <span className={shared.label}>Width</span>
            <Slider min={1} max={10} value={options.width} onChange={(value) => set('width', value)} className={styles.slider} />

            <div className={styles.row}>
                <span className={shared.label}>Colour</span>
                <Tooltip title="Pen colour" placement="right">
                    <input
                        type="color"
                        className={shared.swatch}
                        value={options.color}
                        aria-label="Pen colour"
                        onChange={(e) => set('color', e.target.value)}
                    />
                </Tooltip>
            </div>

            <span className={shared.label}>Line</span>
            <div className={shared.segments}>
                {LINE_STYLES.map(([key, name, LineIcon]) => (
                    <Tooltip key={key} title={name}>
                        <button
                            type="button"
                            className={`${shared.segment} ${lineStyle === key ? shared.segmentActive : ''}`}
                            aria-label={name}
                            aria-pressed={lineStyle === key}
                            onClick={() => set('lineStyle', key)}
                        >
                            <LineIcon />
                        </button>
                    </Tooltip>
                ))}
            </div>
        </Flyout>
    );
};

export default PenFlyout;
